var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:'x-icon iconfont ' + _vm.name,style:(_vm.styles),on:{"click":_vm.iconClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }